/**
 * Currency changes between tabs of one browser. The server also pushes `user:currency` to every
 * socket; this channel is the fallback for a tab whose socket is down when the change is made.
 */

export interface CurrencyChange {
  currency?: string;
  baseCurrency?: string;
}

const CHANNEL_NAME = "skystake:wallet-currency";

let channel: BroadcastChannel | null = null;

const openChannel = (): BroadcastChannel | null => {
  if (typeof BroadcastChannel === "undefined") return null;
  channel ??= new BroadcastChannel(CHANNEL_NAME);
  return channel;
};

/** Sent only by the tab that made the change, with the server's answer, so a stale tab never speaks. */
export const announceCurrencyChange = (change: CurrencyChange): void => {
  try {
    openChannel()?.postMessage({ currency: change.currency, baseCurrency: change.baseCurrency });
  } catch {
    // The socket push still reaches the other tabs.
  }
};

export const onCurrencyChange = (listener: (change: CurrencyChange) => void): (() => void) => {
  const open = openChannel();
  if (!open) return () => undefined;
  const handle = (event: MessageEvent<CurrencyChange>) => listener(event.data ?? {});
  open.addEventListener("message", handle);
  return () => open.removeEventListener("message", handle);
};
